var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "_tabs",
      class: _vm._class,
      style: { width: _vm.width, height: _vm.height }
    },
    [
      _c(
        "div",
        {
          staticClass: "_tabc",
          class: { _taboh: _vm.overflowHack },
          style: { height: _vm.content ? null : _vm.height }
        },
        [
          _vm._t("start"),
          _vm.$device.hasMouse
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showBack,
                      expression: "showBack"
                    }
                  ],
                  staticClass: "_tabback"
                },
                [
                  _c(
                    "ib-button",
                    {
                      staticClass: "link mirror-rtl",
                      on: { click: _vm.prevPage }
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              d:
                                "M14.78 2.28l-9 9-.69.72.7.72 9 9 1.43-1.44L7.94 12l8.28-8.28z"
                            }
                          })
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            _vm._g(
              {
                ref: "tabb",
                staticClass: "_tabb",
                class: { _tabsc: !_vm.$device.hasMouse }
              },
              _vm.$device.hasMouse ? { scroll: _vm.scroll } : null
            ),
            [
              _c(
                "div",
                {
                  ref: "tabl",
                  staticClass: "_tabl",
                  attrs: { role: "tablist" }
                },
                _vm._l(_vm.$slots.default, function(tab, i) {
                  return _vm.tabs[i]
                    ? _c("ib-tab-title", {
                        key: i,
                        ref: "tab",
                        refInFor: true,
                        attrs: { vnode: tab, appearance: _vm.appearance },
                        on: { click: _vm.goto }
                      })
                    : _vm._e()
                }),
                1
              ),
              _vm.appearance != "clear"
                ? _c("div", {
                    ref: "tabu",
                    staticClass: "_tabu",
                    attrs: { "aria-hidden": "true" }
                  })
                : _vm._e()
            ]
          ),
          _vm.$device.hasMouse
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showNext,
                      expression: "showNext"
                    }
                  ],
                  staticClass: "_tabnext"
                },
                [
                  _c(
                    "ib-button",
                    {
                      staticClass: "link mirror-rtl",
                      on: { click: _vm.nextPage }
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              d:
                                "M8.7 2.3L7.3 3.7l8.29 8.3-8.3 8.3 1.42 1.4 9.7-9.7z"
                            }
                          })
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._t("end")
        ],
        2
      ),
      _c("div", { staticClass: "_tabp" }, [_vm._t("default")], 2)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }